import { Stack } from '@chronosphereio/chrono-ui';
import { forwardRef, type ReactNode } from 'react';

export interface QueryEditorContainerProps {
  children: ReactNode;
}

/**
 * Bordered frame wrapping the full editor experience (toolbar, input area,
 * action panels, options). No padding — children own their own spacing.
 *
 * Supports ref forwarding so consumers (or actions like an AI assistant) can
 * scope keyboard shortcuts to the container's focus boundary.
 */
export const QueryEditorContainer = forwardRef<HTMLDivElement, QueryEditorContainerProps>(function QueryEditorContainer(
  { children },
  ref
) {
  return (
    <Stack
      ref={ref}
      border="1px solid"
      borderColor="divider"
      borderRadius={1}
      overflow="hidden"
      sx={(theme) => ({
        '&:focus-within': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: '-1px',
          '.cm-gutters, .cm-editor': {
            backgroundColor: 'transparent',
          },
        },
      })}
    >
      {children}
    </Stack>
  );
});
